import { Point, type CanvasComponent, type ILabel } from '@ardoq/yfiles';
import type { ViewportPoint } from '@ardoq/popovers';
import type { URLFieldValue } from '@ardoq/graph';
import { graphLocationToPageLocation } from './graphLocationToPageLocation';
import { getLabelOwnerUrlFieldValues } from 'yfilesExtensions/styles/util';

export type UrlFieldValuesPopoverState = {
  point: ViewportPoint;
  urlFieldValues: URLFieldValue[];
  element: HTMLElement;
};

export type SetUrlFieldValuesPopover = (
  state: UrlFieldValuesPopoverState | null
) => void;

/** @returns the state needed to render the popover, or `null` if none should be shown. */
const getUrlFieldValuesPopoverState = (
  canvasComponent: CanvasComponent,
  label: ILabel
): UrlFieldValuesPopoverState | null => {
  const {
    owner,
    layout: {
      bounds: { centerX: popoverAnchorX, y: popoverAnchorY },
    },
  } = label;
  if (!owner || !canvasComponent) {
    return null;
  }

  const location = graphLocationToPageLocation(
    canvasComponent,
    new Point(popoverAnchorX, popoverAnchorY)
  );

  const urlFieldValues = getLabelOwnerUrlFieldValues(owner);

  if (!location || !urlFieldValues) {
    return null;
  }

  const { x, y } = location;
  return {
    point: { x, y },
    urlFieldValues,
    element: canvasComponent.htmlElement,
  };
};
export { getUrlFieldValuesPopoverState };
